import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=4b9eddd6&scoped=true&"
import script from "./FileUpload.vue?vue&type=script&lang=ts&setup=true&"
export * from "./FileUpload.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./FileUpload.vue?vue&type=style&index=0&id=4b9eddd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9eddd6",
  null
  
)

export default component.exports